import { z } from 'zod';
export const MeetingEntityTypeSchema = z.enum(['claim', 'job']);
export const MeetingEntityTypeEnum = MeetingEntityTypeSchema.enum;
